import { allImages } from "../images";
import { Leaders } from "../../models/models";
const leaders: Leaders[] = [
    {
        id: 1,
        name: 'Sri Rajesh Poosarla',
        email: 'rajesh@pbltransport.co.in',
        tag: 'Providing visionary leadership and driving strategic growth for the organization.',
        role: 'Managing Director',
        image: allImages.nclogo,
    },
    {
        id: 2,
        name: 'Smt Archana Poosarla',
        email: 'Archana@pbltransport.co.in',
        tag: 'Overseeing day-to-day operations and ensuring seamless execution of company goals.',
        role: 'Whole-Time Director',
        image: allImages.nclogo,
    },
    {
        id: 3,
        name: 'Sri CH. V Appa Rao',
        email: 'Appa@pbltransport.co.in',
        tag: 'Guiding the organization with expertise and a focus on sustainable development.',
        role: 'Director',
        image: allImages.nclogo,
    },
];
export default leaders